import { Component, OnInit } from '@angular/core';
import { TranslateService }  from '@ngx-translate/core';
import { UIRouter }          from '@uirouter/core';

import { CompanyService }       from '../companies/company.service';
import { EditComponent }        from '../table/cell-components/actions/edit.component';
import { Table }                from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }         from '../table/table.service';
import { UserModel }            from './typings/user';
import { UsersFilterModel }     from './typings/users.filter';
import { UsersService }         from './users.service';

@Component({
  selector   : 'wor-users',
  template: require('./users.component.html')
})
export class UsersComponent implements OnInit {
  filtering : UsersFilterModel = {
    query: ''
  };

  users : Array<UserModel> = [];

  tableSettings : Table = {
    broadcast: this.usersService.broadcastKey,
    cache    : {
      enabled: true,
      key    : this.usersService.tableCacheKey
    },
    columns: [
      {
        field : 'username',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.USERNAME')
        }
      },
      {
        field : 'group_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.GROUP')
        }
      },
      {
        field : 'state',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( user : UserModel ) => this.view(user)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_USERS')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.usersService.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => this.usersService.getCount(this.filtering.query)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: this.tableService.setSortingFromCache(this.usersService.tableCacheKey, {
      direction: 'asc',
      field    : 'username'
    })
  };

  constructor (
    public  companyService  : CompanyService,
    private router          : UIRouter,
    private tableService    : TableService,
    private translateService: TranslateService,
    private usersService    : UsersService,
  ) {}

  ngOnInit () : void {
    const cache = this.tableService.getCacheForTable(this.usersService.tableCacheKey);

    this.filtering.query = cache.filtering.query || '';

    this.get({
      direction: cache.sorting.direction || 'asc',
      field    : cache.sorting.field     || 'username',
      offset   : cache.paging.offset     || 0,
      pageSize : cache.paging.pageSize   || 11
    });
  }

  filter () : void {
    if ( window[ this.usersService.broadcastKey ] ) {
      window[ this.usersService.broadcastKey ](this.filtering.query);
    }
  }

  get ( params : TableQueryParameters ) : Promise<Array<UserModel>> {
    return this.usersService.get(this.filtering, params)
      .then(( users : Array<UserModel> ) => {
        this.users = users;

        return users;
      });
  }

  view ( user : UserModel ) : void {
    this.router.stateService.go('app.user', {
      id: user.id
    });
  }
}
